<div class="page-container">
  <pvmo-page id="page-simulation" [hidden]="!isUserConnected()">
  </pvmo-page>
</div>

